import React from 'react';
import { formatProjectStatus, getStatusBadgeColor } from '@/lib/statusUtils';

interface StatusBadgeProps {
  status: string;
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
  const displayText = formatProjectStatus(status);
  const colorClasses = getStatusBadgeColor(status);
  
  return (
    <span 
      className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border ${colorClasses} ${className}`}
    >
      {displayText}
    </span>
  );
};

export default StatusBadge;
